<script>
export default {
    name: "Badge",

    props: {
        label: {
            type: String,
            required: true,
        },
        alternative: {
            type: Boolean,
            default: false,
        },
    }
}
</script>

<template>
    <span class="vue-badge" :class="{'alternative': alternative}">
        <slot></slot>

        {{ label }}
    </span>
</template>
